import React from "react";
import { useLanguage } from "../context/LanguageContext";

const TeamHistory = () => {
  const { translate } = useLanguage();

  const teamMembers = [
    {
      name: "Ahmad Fauzi",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=400&q=80",
      role: "role-ceo",
      description: "ceo-desc",
    },
    {
      name: "Sari Dewi",
      image:
        "https://images.unsplash.com/photo-1494790108755-2616c113a1c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=400&q=80",
      role: "role-cto",
      description: "cto-desc",
    },
    {
      name: "Budi Santoso",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=400&q=80",
      role: "role-product",
      description: "product-desc",
    },
    {
      name: "Maya Indah",
      image:
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=400&q=80",
      role: "role-dev",
      description: "dev-desc",
    },
  ];

  // Fungsi fallback yang lebih baik - tanpa external URLs
  const handleImageError = (e, name, index) => {
    e.target.style.display = "none";

    // Buat div placeholder dengan initial
    const parent = e.target.parentElement;
    const initial = name.charAt(0);

    // Cek apakah sudah ada placeholder
    const existingPlaceholder = parent.querySelector(".member-initial");
    if (existingPlaceholder) return;

    const placeholder = document.createElement("div");
    placeholder.className = "member-initial";
    placeholder.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, var(--primary-blue), var(--accent-teal));
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 48px;
      font-weight: bold;
      border-radius: 50%;
      z-index: 2;
    `;
    placeholder.textContent = initial;
    parent.appendChild(placeholder);
  };

  return (
    <section className="team-history" id="team">
      <div className="container">
        <div className="section-title">
          <h2>{translate("team-title")}</h2>
          <p>{translate("team-desc")}</p>
        </div>

        <div className="team-history-container">
          <div className="team-section">
            <h3
              style={{
                color: "var(--dark-blue)",
                marginBottom: "25px",
                fontSize: "1.5rem",
              }}
            >
              {translate("our-team")}
            </h3>
            <div className="team-grid">
              {teamMembers.map((member, index) => (
                <div className="team-member" key={index}>
                  <div
                    className="member-photo"
                    style={{ position: "relative" }}
                  >
                    <img
                      src={member.image}
                      alt={member.name}
                      loading="lazy"
                      style={{
                        position: "relative",
                        zIndex: 1,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      onError={(e) => handleImageError(e, member.name, index)}
                    />
                    {/* Fallback background dengan initial */}
                    <div
                      className="member-photo-fallback"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background:
                          "linear-gradient(135deg, var(--primary-blue), var(--accent-teal))",
                        display: "none",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontSize: "48px",
                        fontWeight: "bold",
                        borderRadius: "50%",
                        zIndex: 0,
                      }}
                      data-initial={member.name.charAt(0)}
                    >
                      {member.name.charAt(0)}
                    </div>
                  </div>
                  <h3 className="member-name">{member.name}</h3>
                  <p className="member-role">{translate(member.role)}</p>
                  <p>{translate(member.description)}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Sejarah Kami section tetap sama */}
          <div className="history-section">
            <h2>
              <i className="fas fa-history"></i>{" "}
              <span>{translate("history-title")}</span>
            </h2>

            <div className="history-content">
              <p>{translate("history-desc1")}</p>
              <p>{translate("history-desc2")}</p>
            </div>

            <div className="history-highlights">
              <div className="highlight-item">
                <div className="highlight-icon">
                  <i className="fas fa-rocket"></i>
                </div>
                <div>
                  <h4 style={{ marginBottom: "5px" }}>
                    {translate("highlight1-title")}
                  </h4>
                  <p style={{ fontSize: "0.9rem" }}>
                    {translate("highlight1-desc")}
                  </p>
                </div>
              </div>

              <div className="highlight-item">
                <div className="highlight-icon">
                  <i className="fas fa-award"></i>
                </div>
                <div>
                  <h4 style={{ marginBottom: "5px" }}>
                    {translate("highlight2-title")}
                  </h4>
                  <p style={{ fontSize: "0.9rem" }}>
                    {translate("highlight2-desc")}
                  </p>
                </div>
              </div>

              <div className="highlight-item">
                <div className="highlight-icon">
                  <i className="fas fa-users"></i>
                </div>
                <div>
                  <h4 style={{ marginBottom: "5px" }}>
                    {translate("highlight3-title")}
                  </h4>
                  <p style={{ fontSize: "0.9rem" }}>
                    {translate("highlight3-desc")}
                  </p>
                </div>
              </div>

              <div className="highlight-item">
                <div className="highlight-icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <div>
                  <h4 style={{ marginBottom: "5px" }}>
                    {translate("highlight4-title")}
                  </h4>
                  <p style={{ fontSize: "0.9rem" }}>
                    {translate("highlight4-desc")}
                  </p>
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: "25px",
                paddingTop: "20px",
                borderTop: "1px solid rgba(26, 107, 255, 0.2)",
              }}
            >
              <h4 style={{ color: "var(--dark-blue)", marginBottom: "10px" }}>
                {translate("vision-mission")}
              </h4>
              <p style={{ fontSize: "0.95rem" }}>
                <strong>{translate("vision-label")}</strong>{" "}
                {translate("vision-text")}
              </p>
              <p style={{ fontSize: "0.95rem" }}>
                <strong>{translate("mission-label")}</strong>{" "}
                {translate("mission-text")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamHistory;
